module.exports = __webpack_public_path__ + "static/media/region-web.5708ff86.svg";